import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getAllSettings, createSetting, updateSetting } from '@services/settings';
import { toast } from 'react-toastify';
import { SETTINGS_QUERY_KEY } from './useSettings';
import { useTranslation } from '@hooks/useTranslation';

export const useUpdateMinVersion = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (minVersion: string) => {
      // Get current settings to check if minVersion exists
      const response = await getAllSettings();
      const minVersionSetting = response.settings.find(
        (s) => s.name === 'minVersion',
      );

      if (minVersionSetting?.settingId) {
        // Update existing setting
        return await updateSetting(minVersionSetting.settingId, {
          value: minVersion,
        });
      } else {
        // Create new setting
        return await createSetting({
          name: 'minVersion',
          value: minVersion,
        });
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SETTINGS_QUERY_KEY });
      toast.success(tActionMessages.minimumVersionUpdatedSuccessfully);
    },
    onError: (error: any) => {
      const message = error?.response?.errors?.[0]?.message || tActionMessages.requestError;
      toast.error(message);
    },
  });
};

export default useUpdateMinVersion;
